/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-pause-outline': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M8.75 6.25H7.5v7.5h1.25v-7.5zm3.75 0h-1.25v7.5h1.25v-7.5zM10 2.5a7.5 7.5 0 110 15 7.5 7.5 0 010-15zm0-1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5z"/>'
  }
})
